function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
export class BarChartGroupedLayout {}

_defineProperty(BarChartGroupedLayout, "BAR_SIZE", 0.5);

_defineProperty(BarChartGroupedLayout, "BAR_GAP", 0.125);

_defineProperty(BarChartGroupedLayout, "MIN_GROUP_DISTANCE", 1.5);

_defineProperty(BarChartGroupedLayout, "MAX_GROUP_DISTANCE", 20.0);
